import { render, staticRenderFns } from "./supplyUnit.vue?vue&type=template&id=23ee5b06"
import script from "./supplyUnit.vue?vue&type=script&lang=js"
export * from "./supplyUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports